import apiClient from "./api";
const SOLICITUDESESTUDIOS_API_BASE_URL = "/solicitudesEstudios";
class SolicitudesEstudiosService {

    async getEstudiosPorSolicitud(solicitudId) {
        try {
            const response = await apiClient.get(
                `${SOLICITUDESESTUDIOS_API_BASE_URL}/solicitud/${solicitudId}`,
            );
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    async getEstatusSubPorSolicitud(solicitudId) {
        try {
            const response = await apiClient.get(
                `${SOLICITUDESESTUDIOS_API_BASE_URL}/subEstatus/${solicitudId}`,
            );
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    async getEstudiosUrgentes() {
        try {
            const response = await apiClient.get(
                `${SOLICITUDESESTUDIOS_API_BASE_URL}/urgentes`,
            );
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    deleteEstudio(estudio) {
        return apiClient.delete(`${SOLICITUDESESTUDIOS_API_BASE_URL}`, {
            headers: { "Content-Type": "application/json" },
            data: estudio,
        });
    }

    updateEstatusEstudio(estudio, estudioId) {
        return apiClient.put(SOLICITUDESESTUDIOS_API_BASE_URL + "/estatus/" + estudioId, estudio);
    }

    updateRegistroMuestra(registro) {
        return apiClient.put(SOLICITUDESESTUDIOS_API_BASE_URL + "/registroMuestra", registro);
    }

    async getRecepcionMuestrasPorSolicitud(solicitudId) {
        try {
            const response = await apiClient.get(
                `${SOLICITUDESESTUDIOS_API_BASE_URL}/recepcionMuestras/${solicitudId}`,
            );
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    async getTomaMuestras() {
        try {
            const response = await apiClient.get(
                `${SOLICITUDESESTUDIOS_API_BASE_URL}/tomaMuestras`,
            );
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    registrarTomaMuestra(registro) {
        return apiClient.put(
            `${SOLICITUDESESTUDIOS_API_BASE_URL}/tomaMuestras`,
            registro,
        );
    }
}
export default new SolicitudesEstudiosService();
